import { stats } from 'instantsearch.js/es/widgets'
import { wptemplate } from '../../../helper-functions'

/**
 * Load the Stats widgets.
 *
 * @param {Element} mainContainer The main search container.
 * @returns {Array} The stats widgets.
 */
export default function statsWidgets( mainContainer ) {
  const widgets = []

  Array.from( mainContainer.querySelectorAll( '.js-instant-search-stats' ) ).forEach(
    element => {
      widgets.push(
        stats({
          container: element,
          templates: {
            text: data => wptemplate( 'instantsearch-stats' )( data )
          }
        })
      )
    })

  return widgets
}
